var _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurveCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wave",
    style: {
      transform: "rotate(0deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 490",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(237, 243, 255, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(237, 243, 255, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,0L80,24.5C160,49,320,98,480,171.5C640,245,800,343,960,334.8C1120,327,1280,212,1440,155.2C1600,98,1760,98,1920,106.2C2080,114,2240,131,2400,147C2560,163,2720,180,2880,155.2C3040,131,3200,65,3360,32.7C3520,0,3680,0,3840,73.5C4000,147,4160,294,4320,294C4480,294,4640,147,4800,73.5C4960,0,5120,0,5280,24.5C5440,49,5600,98,5760,138.8C5920,180,6080,212,6240,253.2C6400,294,6560,343,6720,302.2C6880,261,7040,131,7200,106.2C7360,82,7520,163,7680,204.2C7840,245,8000,245,8160,269.5C8320,294,8480,343,8640,359.3C8800,376,8960,359,9120,367.5C9280,376,9440,408,9600,367.5C9760,327,9920,212,10080,212.3C10240,212,10400,327,10560,359.3C10720,392,10880,343,11040,334.8C11200,327,11360,359,11440,375.7L11520,392L11520,490L11440,490C11360,490,11200,490,11040,490C10880,490,10720,490,10560,490C10400,490,10240,490,10080,490C9920,490,9760,490,9600,490C9440,490,9280,490,9120,490C8960,490,8800,490,8640,490C8480,490,8320,490,8160,490C8000,490,7840,490,7680,490C7520,490,7360,490,7200,490C7040,490,6880,490,6720,490C6560,490,6400,490,6240,490C6080,490,5920,490,5760,490C5600,490,5440,490,5280,490C5120,490,4960,490,4800,490C4640,490,4480,490,4320,490C4160,490,4000,490,3840,490C3680,490,3520,490,3360,490C3200,490,3040,490,2880,490C2720,490,2560,490,2400,490C2240,490,2080,490,1920,490C1760,490,1600,490,1440,490C1280,490,1120,490,960,490C800,490,640,490,480,490C320,490,160,490,80,490L0,490Z"
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-1",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(209, 220, 248, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(209, 220, 248, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 50px)",
      opacity: 0.9
    },
    fill: "url(#sw-gradient-1)",
    d: "M0,98L80,106.2C160,114,320,131,480,171.5C640,212,800,278,960,318.5C1120,359,1280,376,1440,392C1600,408,1760,425,1920,367.5C2080,310,2240,180,2400,106.2C2560,33,2720,16,2880,32.7C3040,49,3200,98,3360,163.3C3520,229,3680,310,3840,334.8C4000,359,4160,327,4320,261.3C4480,196,4640,98,4800,57.2C4960,16,5120,33,5280,73.5C5440,114,5600,180,5760,171.5C5920,163,6080,82,6240,49C6400,16,6560,33,6720,32.7C6880,33,7040,16,7200,81.7C7360,147,7520,294,7680,326.7C7840,359,8000,278,8160,228.7C8320,180,8480,163,8640,204.2C8800,245,8960,343,9120,326.7C9280,310,9440,180,9600,155.2C9760,131,9920,212,10080,261.3C10240,310,10400,327,10560,343C10720,359,10880,376,11040,375.7C11200,376,11360,359,11440,351.2L11520,343L11520,490L11440,490C11360,490,11200,490,11040,490C10880,490,10720,490,10560,490C10400,490,10240,490,10080,490C9920,490,9760,490,9600,490C9440,490,9280,490,9120,490C8960,490,8800,490,8640,490C8480,490,8320,490,8160,490C8000,490,7840,490,7680,490C7520,490,7360,490,7200,490C7040,490,6880,490,6720,490C6560,490,6400,490,6240,490C6080,490,5920,490,5760,490C5600,490,5440,490,5280,490C5120,490,4960,490,4800,490C4640,490,4480,490,4320,490C4160,490,4000,490,3840,490C3680,490,3520,490,3360,490C3200,490,3040,490,2880,490C2720,490,2560,490,2400,490C2240,490,2080,490,1920,490C1760,490,1600,490,1440,490C1280,490,1120,490,960,490C800,490,640,490,480,490C320,490,160,490,80,490L0,490Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveCard);
export default __webpack_public_path__ + "static/media/CurveCard.ea285a3d2e5e22af6aa18ed447a9d162.svg";
export { ForwardRef as ReactComponent };